import { render, staticRenderFns } from "./AppHeaderUniversal.vue?vue&type=template&id=79bdd05b&scoped=true"
import script from "./AppHeaderUniversal.vue?vue&type=script&lang=js"
export * from "./AppHeaderUniversal.vue?vue&type=script&lang=js"
import style0 from "./AppHeaderUniversal.vue?vue&type=style&index=0&id=79bdd05b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bdd05b",
  null
  
)

export default component.exports